import React, { useEffect, useState } from "react";
import { Badge, Button } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useNavigate } from "react-router-dom";
import authApi from "../../api/authApi";
import jwt_decode from "jwt-decode";
import { isMobile } from 'react-device-detect';
import { usePermission } from "../context/PermissionContext";

const Header = ({ socket }) => {

  const navigate = useNavigate();
  const [userinfo, setUser] = useState({});
  const {userInfo } = usePermission();
  useEffect(() => {
    if (!sessionStorage.getItem("token")) navigate("/login");

    try {
      setUser(jwt_decode(sessionStorage.getItem('token')));
    } catch (error) {
      console.error("Error", error.messages)
    }

  }, [userInfo]);

  const logout = () => {
    authApi.logout();
    navigate("/login");
  };

  const toggleSidebar = () => {
    document.querySelector("#sidebar").classList.toggle("hide");
    document.querySelector("#sidebar").classList.toggle("show");
  };

  return (
    <>
      <Navbar className="header px-2" bg="" expand="lg" variant="" style={{ marginBottom: isMobile ? "1rem" : "0" }}>
        <button
          type="button"
          id="sidebarCollapse"
          className="btn btn-info"
          onClick={toggleSidebar}
        >
          <i className="fas fa-align-left"></i>
        </button>
        <Navbar.Brand href="#home"></Navbar.Brand>
        <Navbar aria-controls="basic-navbar-nav" />
        <Navbar id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/myprofile" className="p-0" style={{ fontSize: ".9rem" }}>
              {userinfo?.picture && <img src={`${userinfo?.picture}`} className="rounded-circle" style={{ height: "30px", width: "30px", objectFit: "cover" }} />}
              <img src="/srmlogo.jpg" style={{ height: "30px", width: "30px" }} />

              <Badge style={{ fontSize: "13px" }} bg="light" text="dark">{userinfo?.username} </Badge>
              <Badge bg="success" style={{ fontSize: "13px" }}>{userinfo?.userrole} </Badge> </Nav.Link>

            <Nav.Link href="#" className="d-flex p-0" style={{ alignItems: "center" }}><span className="mx-2" style={{ fontSize: "13px" }}>Company</span> <Badge style={{ fontSize: "13px" }} bg="secondary">{userinfo?.companyname} </Badge> </Nav.Link>
          </Nav>
          <Nav className="ml-auto d-flex align-items-center">
            {/* <div class="icon-wrapper">
              <i className="fa-solid fa-bell cic mx-2" onClick={openNotificationArea} style={{ cursor: "pointer", fontSize: "1.5rem" }}></i>
              {showBellAlert && <span class="notify-number">{unreadMsgCount}</span>}
            </div> */}
            {/* {showNotification && */}
              {/* <Notification notifications={messages} closeNotification={closeNotification} refreshNotification={refreshNotification} />} */}
            {sessionStorage.getItem("token") ? (
              <Button className="logout" variant="btn btn-primary" onClick={logout} title="Logout">
                <i className="fa-solid fa-right-from-bracket"></i>
              </Button>
            ) : (
              <></>
            )}
          </Nav>
        </Navbar>
        {/* <Navbar.Toggle aria-controls="basic-navbar-nav " /> */}
        {/* <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/myprofile" className="p-0" style={{ fontSize: ".9rem" }}>
              {userInfo.picture && <img src={`${userInfo.picture}`} className="rounded-circle" style={{ height: "30px", width: "30px", objectFit: "cover" }} alt="" />}
              <img src="/srmlogo.jpg" style={{ height: "30px", width: "30px" }} alt="" />

              <Badge style={{ fontSize: ".9rem" }} bg="light" text="dark">{userInfo.username} </Badge>
              <Badge bg="success" style={{ fontSize: ".9rem" }}>{userInfo.userrole} </Badge> </Nav.Link>
            <Nav.Link href="#" className="d-flex p-0" style={{ alignItems: "center" }}><span className="mx-2" style={{ fontSize: ".9rem" }}>Company</span> <Badge style={{ fontSize: ".9rem" }} bg="secondary">{userInfo.companyname} </Badge> </Nav.Link>
          </Nav>
          <Nav className="ml-auto d-flex align-items-center ">
            {sessionStorage.getItem("token") ? (
              <Button variant="btn btn-primary" onClick={logout} title="Logout">
                <i className="fa-solid fa-right-from-bracket"></i>
              </Button>
            ) : (
              <></>
            )}
          </Nav>
        </Navbar.Collapse> */}
      </Navbar>
    </>
  );
};
export default Header;